import React, { PropsWithChildren } from 'react';
import { BannersWrapper } from 'src/domains/layouts/webview/components/banners/Banners.style';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/domains/common/Common';
import { StreamingState } from 'src/domains/sportsbook/state/streamingState/StreamingState';
import { AppLayoutsState } from 'src/domains/layouts/state/AppLayouts.state';

export const Banners = observer('Banners', (props: PropsWithChildren<unknown>) => {
    const { children } = props;

    const common = useCommon();
    const appLayoutsState = AppLayoutsState.get(common);
    const { bannersBoxState } = appLayoutsState;
    const streamingState = StreamingState.get(common);

    const streamBoxHeight = streamingState.streamViewDetails.boxHeight;
    const streamFloating = streamingState.streamViewDetails.isFloating;

    const fixedStreamHeight = streamBoxHeight - 1; // Remove 1px hap between stream and main header.

    return (
        <BannersWrapper
            ref={bannersBoxState.setRef}
            offsetTop={fixedStreamHeight}
            isStreamFloating={streamFloating}
        >
            {children}
        </BannersWrapper>
    );
});
